import {
    clearNotifications,
    showError,
    showInfo
} from "./../../../../notifications/ducks/actions";
import getApiClient from "./../../../../shared/api";
import { getActionToUploadImagesAndSaveEntity } from "./../../../../shared/image-action-creator";

export const CHANGE_ANIMAL_TO_PROP = "CHANGE_ANIMAL_TO_PROP";
export const ANIMAL_SET_RETURN_URL = "ANIMAL_SET_RETURN_URL";
export const ANIMAL_SCENE_SETTING = "ANIMAL_SCENE_SETTING";

export function fetchAnimals(filmId) {
    return (dispatch) => {
        dispatch({
            type: "FETCH_ANIMALS",
            payload: getApiClient().get(`/film/${filmId}/animal`)
        });
    };
}

export function setReturnUrl(returnUrl) {
    return (dispatch) => {
        dispatch({
            type: ANIMAL_SET_RETURN_URL,
            meta: { returnUrl }
        });
    };
}

export function clearAnimal() {
    return (dispatch) => {
        dispatch({
            type: "CLEAR_ANIMAL"
        });
    };
}

export function setNameAndSceneSetting(name, sceneSettingId) {
    return (dispatch) => {
        dispatch({
            type: "ANIMAL_SET_NAME_AND_SCENE_SETTING",
            meta: { name, sceneSettingId }
        });
    };
}

export function setSceneSetting(sceneSettingId) {
    return (dispatch) => {
        dispatch({
            type: ANIMAL_SCENE_SETTING,
            meta: { sceneSettingId }
        });
    };
}


export function fetchNextAnimalNumber(filmId) {
    return (dispatch) => {
        dispatch({
            type: "FETCH_NEXT_ANIMAL_NUMBER"
        });
    };
}

export function fetchAnimal(filmId, animalId) {
    return (dispatch) => {
        dispatch({
            type: "FETCH_SINGLE_ANIMAL",
            payload: getApiClient().get(`/film/${filmId}/animal/${animalId}`)
        });
    };
}

export function updateAnimal(filmId, animal) {
    return (dispatch) => {
        dispatch({
            type: "UPDATE_SINGLE_ANIMAL",
            payload: getApiClient().put(`/film/${filmId}/animal/${animal.id}`, animal),
            meta: { animal }
        })
            .then((response) => {
                dispatch(showInfo(`Updated Animal ${animal.name}`));
            })
            .catch((response) => {
                dispatch(showError(`Error updating Animal ${animal.name}`));
            })
            .then((response) => {
                dispatch(clearNotifications());
            });
    };
}

export function changeAnimalToProp(filmId, animal) {
    return (dispatch) => {
        dispatch({
            type: CHANGE_ANIMAL_TO_PROP,
            payload: getApiClient().put(`/film/${filmId}/animal/${animal.id}/ChangeToProp`, animal),
            meta: { animal }
        })
            .then((response) => {
                dispatch(showInfo(`Changed Animal ${animal.name} to Prop`));
            })
            .catch((response) => {
                dispatch(showError(`Error changing Animal ${animal.name} to Prop`));
            })
            .then((response) => {
                dispatch(clearNotifications());
            });
    };
}

function addAnimalWithImageUrls(dispatch, animal, filmId) {
    dispatch({
        type: "ADD_SINGLE_ANIMAL",
        payload: getApiClient().post(`/film/${filmId}/animal/`, animal),
        meta: { animal }
    })
        .then((response) => {
            dispatch(showInfo(`Added Animal ${animal.name}`));
        })
        .then((response) => {
            dispatch(clearNotifications());
        });
}

function updateAnimalWithImageUrls(dispatch, animal, filmId) {
    dispatch({
        type: "UPDATE_SINGLE_ANIMAL",
        payload: getApiClient().put(`/film/${filmId}/animal/${animal.id}`, animal),
        meta: { animal }
    })
        .then((response) => {
            dispatch(showInfo(`Updated animal ${animal.name}`));
        })
        .then((response) => {
            dispatch(clearNotifications());
        });
}

export const uploadImagesAndSaveAnimal = getActionToUploadImagesAndSaveEntity(
    addAnimalWithImageUrls,
    updateAnimalWithImageUrls
);

export function addAnimal(filmId, animal) {
    return (dispatch) => {
        dispatch({
            type: "ADD_SINGLE_ANIMAL",
            payload: getApiClient().post(`/film/${filmId}/animal/`, animal),
            meta: { animal }
        })
            .then((response) => {
                dispatch(showInfo(`Added Animal ${animal.name}`));
            })
            .catch((response) => {
                dispatch(showError(`Error adding Animal`));
            })
            .then((response) => {
                dispatch(clearNotifications());
            });
    };
}

export function deleteAnimal(filmId, animal) {
    return (dispatch) => {
        dispatch({
            type: "DELETE_SINGLE_ANIMAL",
            payload: getApiClient().delete(`/film/${filmId}/animal/${animal.id}`),
            meta: { animal }
        })
            .then((response) => {
                dispatch(showInfo(`Deleted Animal ${animal.name}`));
            })
            .catch((response) => {
                dispatch(showError(`Error deleting Animal ${animal.name}`));
            })
            .then((response) => {
                dispatch(clearNotifications());
            });
    };
}

export function addImageFiles(imageFiles) {
    return (dispatch) => {
        dispatch({
            type: "ADD_ANIMAL_IMAGE_FILES",
            meta: { imageFiles }
        });
    };
}

export function addImageUrl(url) {
    return (dispatch) => {
        dispatch({
            type: "ADD_ANIMAL_IMAGE_URL",
            meta: { url }
        });
    };
}

export function deleteImageUrl(url) {
    return (dispatch) => {
        dispatch({
            type: "DELETE_ANIMAL_IMAGE_URL",
            meta: { url }
        });
    };
}

export function deleteImageFile(fileName) {
    return (dispatch) => {
        dispatch({
            type: "DELETE_ANIMAL_IMAGE_FILE",
            meta: { fileName }
        });
    };
}

export function mainImageUrlChanged(url) {
    return (dispatch) => {
        dispatch({
            type: "ANIMAL_MAIN_IMAGE_CHANGED",
            meta: { url }
        });
    };
}

export function clearRedirect(dispatch) {
    return (dispatch) => {
        dispatch({
            type: "CLEAR_REDIRECT"
        });
    };
}

export function fetchScenesAssignedToAnimal(filmId, animalId) {
    return (dispatch) => {
        dispatch({
            type: "FETCH_SCENES_ASSIGNED_TO_ANIMAL",
            payload: getApiClient().get(
                `/film/${filmId}/Animal/${animalId}/AssignedToScenes`
            )
        });
    };
}

export function setSceneAssignedToAnimal(sceneId) {
    return (dispatch) => {
        dispatch({
            type: "SET_SCENE_ASSIGNED_TO_ANIMAL",
            meta: { sceneId }
        });
    };
}

export function assignScenesToAnimal(filmId, animalId, sceneIds) {
    return (dispatch) => {
        dispatch({
            type: "ASSIGN_SCENES_TO_ANIMAL",
            payload: getApiClient().put(
                `/film/${filmId}/animal/${animalId}/AssignToScenes`,
                { sceneIds }
            ),
            meta: { animalId }
        })
            .then((response) => {
                dispatch(showInfo(`Assigned Animal to Scenes`));
            })
            .catch((response) => {
                dispatch(showError(`Error assigning Animal to Scenes`));
            })
            .then((response) => {
                dispatch(clearNotifications());
            });
    };
}

export function fetchAllSceneSettings(filmId) {
    return (dispatch) => {
        dispatch({
            type: "FETCH_ALL_SCENE_SETTINGS_FOR_ANIMAL",
            payload: getApiClient().get(`/film/${filmId}/scenesetting`)
        });
    };
}

export function fetchAllScenes(filmId, sceneSettingId) {
    let filters: string[] = [];

    filters.push(`sceneSettingIds=${sceneSettingId}`);

    return (dispatch) => {
        dispatch({
            type: "FETCH_ALL_SCENES_FOR_ANIMAL",
            payload: getApiClient().get(`/film/${filmId}/scene/search?${filters.join("&")}`)
        });
    };
}

export function findInScript(
    filmId,
    propName
) {
    return (dispatch) => {
        dispatch({
            type: "SEARCH_SCRIPT_FOR_ANIMAL",
            payload: getApiClient().get(
                `/film/${filmId}/script/search/${propName}`
            ),
            meta: { selectSearchedScenes: true }
        });
    };
}


export function clearSceneSearchResults() {
    return (dispatch) => {
        dispatch({
            type: "CLEAR_SEARCH_SCENES_FOR_ANIMAL"
        });
    };
}
